import { render, staticRenderFns } from "./properties-block-card.vue?vue&type=template&id=0264feea&scoped=true"
import script from "./properties-block-card.vue?vue&type=script&lang=js"
export * from "./properties-block-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0264feea",
  null
  
)

export default component.exports